import projectPackage from '../package.json';

const appName = projectPackage.name.replace('@zg-rentals/', '');

export default appName;
